import { createFileRoute } from '@tanstack/react-router'
import OnboardingPage from '@/components/pages/OnboardingPage/OnboardingPage'
import { z } from 'zod'

const onboardingSearchSchema = z.object({
  redirectPage: z.string().optional(),
  redirectUrl: z.string().optional(),
  user_code: z.string().optional(),
  return_to: z.string().optional(),
})

export const Route = createFileRoute('/$workspaceName/$environment/onboarding')({
  validateSearch: (search) => onboardingSearchSchema.parse(search),
  component: OnboardingRoute,
})

function OnboardingRoute() {
  return <OnboardingPage />
}
